import { Icon } from "../../assets";
import { DataLinksProps } from "./App.types";
import { SelectorTypes } from "./components/Selector/Selector.types";

export function getLinks(links: DataLinksProps): SelectorTypes.Props[] {
 return [
  {
   id: "linkRecipesWeb",
   title: "Recetario web",
   text: "Accede a nuestra web de recetas.",
   icon: Icon.Cutlery,
   link: links.linkRecipesWeb || "",
  },
  {
   id: "linkRecipesRobot",
   title: "Recetas",
   text: "Ver catálogo de vídeos de recetas.",
   icon: Icon.Recipes,
   link: links.linkRecipesRobot || "",
  },
  {
   id: "linkContentInVideo",
   title: "Contenido en Video",
   text: "Tutoriales, consejos en nuestro canal",
   icon: Icon.Video,
   link: links.linkContentInVideo || "",
  },
  {
   id: "linkInstagram",
   title: "Redes sociales",
   text: "Accede a nuestro instagram.",
   icon: Icon.Instagram,
   link: links.linkInstagram || "",
  },
  {
   id: "linkManuals",
   title: "Manuales",
   text: "Ver manuales.",
   icon: Icon.Manual,
   link: links.linkManuals || "",
  },
  {
   id: "linkGuideFastStart",
   title: "Guia de inicio rapido",
   text: "Tu robot listo en pocos pasos",
   icon: Icon.Link,
   link: links.linkGuideFastStart || "",
  },
  {
   id: "linkMaintenanceGuide",
   title: "Guía de mantenimiento",
   text: "Como limpiar tu producto.",
   icon: Icon.Clean,
   link: links.linkMaintenanceGuide || "",
  },
  {
   id: "linkCecotecSupport",
   title: "Soporte CecoCare",
   text: "Un link, todas las soluciones",
   icon: Icon.StandbyOff,
   link: links.linkCecotecSupport || "",
  },
 ];
}
